import { combineReducers } from 'redux';
import alerts from './alertReducer';
import theme from './themeReducer';
import analyticsDashboard from './analyticsReducer';
import user from './tieringReducer';
import notification from './notificationReducer';
import bannerInfo from './bannerReducer';
import credentials from './apiCredentialsReducers';
import apobSeller from './apobSellerListReducer';
import combinedSelectApobSeller from './getApobSellerReducer';

export default combineReducers({
  theme,
  analyticsDashboard,
  alerts,
  user,
  bannerInfo,
  notification,
  credentials,
  apobSeller,
  combinedSelectApobSeller,
});
